/*
 * @Author: Gaho
 * @Date: 2024-03-11 13:28:33
 * @LastEditors: Gaho
 * @LastEditTime: 2024-07-08 13:14:48
 * @Description: 
 */
export interface tripleStateTypes {
    str: string;
    odd: string;
}

// triple游戏规则数据-右侧
export const resultRight: any = {
    Low: [
        { str: '022', odd: '3.48' },
        { str: '112', odd: '5.03' },
        { str: '111', odd: '7.00' },
        { str: '122', odd: '15.00' },
        { str: '222', odd: '40.00' },
    ],
    Medium: [
        { str: '022', odd: '7.00' },
        { str: '112', odd: '10.00' },
        { str: '111', odd: '14.35' },
        { str: '122', odd: '30.60' },
        { str: '222', odd: '80.00' },
    ],
    High: [
        { str: '022', odd: '10.24' },
        { str: '112', odd: '15.00' },
        { str: '111', odd: '30.00' },
        { str: '122', odd: '60.00' },
        { str: '222', odd: '200.00' },
    ],
}
// triple游戏规则数据-左侧
export const resultLeft: any = {
    Low: [
        { str: '000', odd: '0.50' },
        { str: '001', odd: '0.80' },
        { str: '002', odd: '1.20' },
        { str: '012', odd: '1.50' },
        { str: '011', odd: '2.40' },
    ],
    Medium: [
        { str: '000', odd: '0.00' },
        { str: '001', odd: '0.50' },
        { str: '002', odd: '1.50' },
        { str: '012', odd: '2.40' },
        { str: '011', odd: '3.30' },
    ],
    High: [
        { str: '000', odd: '0.00' },
        { str: '001', odd: '0.00' },
        { str: '002', odd: '0.50' },
        { str: '012', odd: '3.00' },
        { str: '011', odd: '4.20' },
    ]
};
// triple中间展示区域数据
export const tableArray = [
    { status: '', val: 1 },
    { status: '', val: 2 },
    { status: '', val: 3 },
    { status: '', val: 4 },
    { status: '', val: 5 },
    { status: '', val: 6 },
    { status: '', val: 7 },
    { status: '', val: 8 },
    { status: '', val: 9 },
    { status: '', val: 10 },
    { status: '', val: 11 },
    { status: '', val: 12 },
    { status: '', val: 13 },
    { status: '', val: 14 },
    { status: '', val: 15 },
    { status: '', val: 16 },
    { status: '', val: 17 },
    { status: '', val: 18 },
    { status: '', val: 19 },
    { status: '', val: 20 },
    { status: '', val: 21 },
    { status: '', val: 22 },
    { status: '', val: 23 },
    { status: '', val: 24 },
    { status: '', val: 25 },
    { status: '', val: 26 },
    { status: '', val: 27 },
    { status: '', val: 28 },
    { status: '', val: 29 },
    { status: '', val: 30 },
    { status: '', val: 31 },
    { status: '', val: 32 },
    { status: '', val: 33 },
    { status: '', val: 34 },
    { status: '', val: 35 },
    { status: '', val: 36 },
]
// triple游戏规则数据
export const tripleRuleData = [
    {
        content1: 'tripleRule1',
        constent2: '',
        img: null,
    }
]
